import React, { useContext } from 'react';
import { Menu } from '@mui/icons-material';
import { AppBar, IconButton } from "@mui/material";

import MenuItem from './hoa-side-drawer-menu-item';
import { MenuContainer } from './hoa-side-drawer-styled-content';

import config from '../../hoa-config';
import datastore from '../../store/hoa-datastore';
import { GlobalContext } from '../../context/hoa-global-context';

const MenuContent = () => {

    const { toggleDrawer } = useContext<any>(GlobalContext);

    return (
        <MenuContainer className='side-drawer-menu-container'>
            <AppBar
                position="static"
                style={{ flexDirection: 'row' }}
                className="side-drawer-app-bar-container"
            >
                <img className='side-drawer-logo' style={{cursor: 'pointer'}} onClick={()=>window.open("https://www.insidemaps.com/", "_self")} src='images/logo/logo-black.png' />
                <IconButton style={{ marginRight: '12px' }} onClick={()=>toggleDrawer()}>
                    <Menu style={{ color:'black' }} className="side-drawer-menu-icon-container" />
                </IconButton>
            </AppBar>
            {
                datastore.userRole === config.userRoles.OrganizationUser ?
                    <div className='side-drawer-menu-list-container'>
                        {
                            config.sideDrawerMenuItems.map((name: string, index: number) => {
                                if(name === 'Municipalities') return;
                                return <MenuItem key={index} name={name} />
                            })
                        }
                    </div>
                    :
                    <div className='side-drawer-menu-list-container'>
                        <div className='side-drawer-menu-item-container helperText' style={{marginLeft: 28}}>PENDING TASK</div>
                        {
                            config.sideDrawerMenuTaskItems.map((name: string, index: number) => {

                                return <MenuItem key={index} name={name} />
                            })
                        }
                        <div className='side-drawer-menu-item-container helperText' style={{marginLeft: 28}}>COMPLETED TASK</div>
                        {
                            config.sideDrawerMenuCompletedTaskItems.map((name: string, index: number) => {

                                return <MenuItem key={index} name={name} />
                            })
                        }
                        <div className='side-drawer-menu-item-container helperText' style={{marginLeft: 28}}>DATA</div>
                        {
                            config.sideDrawerMenuItems.map((name: string, index: number) => {

                                return <MenuItem key={index} name={name} />
                            })
                        }
                        <div className='side-drawer-menu-item-container helperText' style={{marginLeft: 28}}>SOURCE</div>
                        {
                            config.sideDrawerMenuInboxItems.map((name: string, index: number) => {

                                return <MenuItem key={index} name={name} />
                            })
                        }
                        <div className='side-drawer-menu-item-container helperText' style={{marginLeft: 28}}>ADDITIONAL</div>
                        {
                            config.sideDrawerMenuAdditionalItems.map((name: string, index: number) => {
                                if(datastore.userRole === 'officer' && name === 'Webhook') return;
                                return <MenuItem key={index} name={name} />
                            })
                        }
                        <div className='side-drawer-menu-item-container helperText' style={{marginLeft: 28}}>INVOICING</div>
                        {
                            config.sideDrawerMenuInvoicing.map((name: string, index: number) => {
                                
                                if(datastore.userRole === 'officer' && name === 'InvoiceDataMapping') return;

                                return <MenuItem key={index} name={name} />
                            })
                        }
                        {
                            datastore.isUserPermitted("Data Field Configurator",'configurator') && 
                            <>
                                <div className='side-drawer-menu-item-container helperText' style={{marginLeft: 28}}>SETTINGS</div>
                                {
                                    config.sideDrawerMenuSettings.map((name: string, index: number) => {

                                        return <MenuItem key={index} name={name} />
                                    })
                                }
                            </>
                        }
                        </div>
            }
            
        </MenuContainer>
    )
}


export default MenuContent